import PropTypes from "prop-types";

import { HeaderWrapper, CancelIconButton } from "pages/Search/components/styles";

const Header = ({ handleDialogClose }) => {
  return (
    <HeaderWrapper>
      <CancelIconButton color="inherit" aria-label="close" onClick={handleDialogClose} size="large">
        Done
      </CancelIconButton>
    </HeaderWrapper>
  );
};

Header.propTypes = {
  handleDialogClose: PropTypes.func.isRequired,
};

export default Header;
